import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useServer } from "@/lib/server-context";
import { toast } from "sonner";
import { Plus, Landmark, Coins } from "lucide-react";
import EmptyServer from "@/components/dashboard/EmptyServer";

export default function EconomyPanel() {
  const { active } = useServer();
  const [board, setBoard] = useState([]);
  const [form, setForm] = useState({ target_user_id: "", amount: 100 });

  const refresh = () => {
    if (!active?.id || !active.bot_present) return;
    api.get(`/features/economy/${active.id}/leaderboard`).then((r) => setBoard(r.data));
  };
  useEffect(refresh, [active?.id, active?.bot_present]);

  if (!active) return <EmptyServer />;
  if (!active.bot_present) return <EmptyServer needsBot />;

  const grant = async (e) => {
    e.preventDefault();
    if (!form.target_user_id || !form.amount) return;
    await api.post(`/features/economy/${active.id}/grant?target_user_id=${form.target_user_id}&amount=${form.amount}`);
    toast.success(`Granted ${form.amount} coins`);
    setForm({ target_user_id: "", amount: 100 });
    refresh();
  };

  return (
    <div data-testid="economy-panel" className="space-y-8 max-w-4xl">
      <div>
        <div className="overline mb-2"><Landmark className="inline w-4 h-4 mr-2 -mt-1" />GAMES & FUN</div>
        <h1 className="font-heading text-4xl font-bold uppercase tracking-tight">Economy</h1>
        <p className="text-zinc-400 mt-2">Server-currency system. Members earn/spend "coins". Use grants to reward.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <form onSubmit={grant} className="tactical-card p-6 space-y-4 lg:col-span-1" data-testid="eco-form">
          <h2 className="font-heading text-lg uppercase">Grant Coins</h2>
          <input className="tactical-input" placeholder="User ID" value={form.target_user_id} onChange={(e) => setForm({ ...form, target_user_id: e.target.value })} data-testid="eco-uid" />
          <input type="number" className="tactical-input" placeholder="Amount" value={form.amount} onChange={(e) => setForm({ ...form, amount: parseInt(e.target.value) || 0 })} data-testid="eco-amount" />
          <button type="submit" className="btn-primary w-full justify-center" data-testid="eco-grant-btn"><Plus className="w-4 h-4" /> Grant</button>
        </form>

        <div className="lg:col-span-2 tactical-card p-6">
          <h2 className="font-heading text-lg uppercase mb-4">Richest Members</h2>
          <div className="space-y-2">
            {board.length === 0 && <div className="text-zinc-500 font-mono-tabular text-sm py-6 text-center">No coins distributed yet</div>}
            {board.map((b, i) => (
              <div key={b.user_id} className="border border-brand-line p-3 rounded-lg flex items-center gap-3" data-testid={`eco-row-${i}`}>
                <div className="font-mono-tabular text-brand-orange w-8 text-right">{i + 1}</div>
                <Coins className="w-4 h-4 text-yellow-400" />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-mono-tabular truncate">{b.user_id}</div>
                </div>
                <div className="font-mono-tabular font-bold">{b.coins?.toLocaleString() || 0}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
